var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea-component"},[_c('b-input',{attrs:{"type":"textarea","placeholder":_vm.placeholder,"required":_vm.required,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }